import { DesignToken } from "@livechat/design-system-react-components";

import { ReportDistribution } from "constants/reports/distribution";
import { duration } from "helpers/date";
import { withVar } from "themes/helpers";

import { getLabelsFromPeriod, getSeriesDataFromPeriod, sumValueFromPeriod } from "../helpers";
import { IChartData } from "../interfaces";

const assignmentColor = withVar(DesignToken.DecorBlue500);
const responseColor = withVar(DesignToken.DecorGreen500);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ticketsTimeDeserializer(data: any, label: string, distribution: ReportDistribution): IChartData {
  const assignmentDataSeconds = getSeriesDataFromPeriod(data, "sumSecondsToAssignment", distribution);
  const responseDataSeconds = getSeriesDataFromPeriod(data, "sumSecondsToResponse", distribution);
  const ticketCountData = getSeriesDataFromPeriod(data, "count", distribution);
  const averageAssignmentDataSeconds = assignmentDataSeconds.map(
    // @ts-expect-error TS(6133): 'value' is declared but its value is never read.
    (value, index) => assignmentDataSeconds[index] / (ticketCountData[index] || 1)
  );
  const averageResponseDataSeconds = responseDataSeconds.map(
    // @ts-expect-error TS(6133): 'value' is declared but its value is never read.
    (value, index) => responseDataSeconds[index] / (ticketCountData[index] || 1)
  );
  const firstResponseTimeSeconds = assignmentDataSeconds.map(
    (value, index) => (value + responseDataSeconds[index]) / (ticketCountData[index] || 1)
  );

  const assignmentTotal = sumValueFromPeriod(data, "sumSecondsToAssignment");
  const responseTotal = sumValueFromPeriod(data, "sumSecondsToResponse");
  const ticketsTotal = sumValueFromPeriod(data, "count");

  const assignmentAverage = assignmentTotal / (ticketsTotal || 1);
  const responseAverage = responseTotal / (ticketsTotal || 1);
  const firstResponseTimeAverage = (assignmentTotal + responseTotal) / (ticketsTotal || 1);

  const labels = getLabelsFromPeriod(data, distribution);

  return {
    summary: [
      {
        name: "Average",
        value: duration(firstResponseTimeAverage),
        rawValue: firstResponseTimeAverage,
      },
      {
        name: "Time to assign to Agent",
        value: duration(assignmentAverage),
        color: assignmentColor,
        rawValue: assignmentAverage,
      },
      {
        name: "Time to respond",
        value: duration(responseAverage),
        color: responseColor,
        rawValue: responseAverage,
      },
    ],
    labels,
    series: [
      {
        name: label,
        data: averageAssignmentDataSeconds,
        color: assignmentColor,
        extras: {
          customAggregate: firstResponseTimeAverage,
          firstResponseTimeSeconds,
          count: ticketCountData,
        },
      },
      {
        name: label,
        data: averageResponseDataSeconds,
        color: responseColor,
        extras: {
          customAggregate: firstResponseTimeAverage,
          firstResponseTimeSeconds,
          count: ticketCountData,
        },
      },
    ],
  };
}
